export const systemConfig = {
  get isLocal() {
    return __LOCAL_DEV__ === 'true';
  },
  get environment() {
    return __ENV__;
  },
  get domain() {
    return __DOMAIN__;
  },
  get subDomain() {
    return __SUB_DOMAIN__;
  },
  get tenantId() {
    return __TENANT_ID__?.toLowerCase();
  },
  get groupName() {
    // Fixed typo here (grouName -> groupName)
    return __GROUP_NAME__;
  },
  get version() {
    return __APP_VERSION__;
  },

  get apiUrl() {
    return __LOCAL_DEV__ === 'true'
      ? `http://localhost:3000`
      : `https://api.${systemConfig.groupName}.${systemConfig.domain}`;
  },
  get inspectConfigUrl() {
    return `https://clivconfig.${systemConfig.domain}/inspect/${systemConfig.tenantId}.json`;
  },
  get configUrl() {
    return `https://clivconfig.${systemConfig.domain}/config/${systemConfig.tenantId}.json`;
  },
};
